import { render, staticRenderFns } from "./CommonContentView.vue?vue&type=template&id=bd1feae0"
import script from "./CommonContentView.vue?vue&type=script&lang=js"
export * from "./CommonContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports